import { QueryClient } from "@tanstack/vue-query"

// One client for the app, so the logout handler can drop every cached response along with the session
export const queryClient = new QueryClient()
